

<div class="container-fluid">
    <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
    <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
    <div class="row" style="margin-top: 10px;" style="padding: 0px;">
      <div class="col-12 flex">
        <div class="p-0" [ngClass]="{'col-1':!showFilter, 'col-3':showFilter}">
          <div class="col-12 flex p-0">

            <div class="col-11 p-0" *ngIf="showFilter">
              <div class="col">
                <div class="row">
                  <div class="col-10" id="multiselectDiv" style="padding-left: 0px;padding-right: 0px;">
                    <div class="col-12">
                    <div class="ui-inputgroup" id="filterLabel">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
                      <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStates"
                        id="multiselectStatuses" [style]="{'width':'68%','padding':'2%'}">
                        <ng-template let-item pTemplate="selectedItem">
                          <span style="vertical-align:middle">{{item.label}}</span>
                        </ng-template>
                        <ng-template let-status pTemplate="item">
                          {{status.label}}
                        </ng-template>
                      </p-multiSelect>
                    </div>
                  </div>
                  </div>
                  <div class="col-2" id="refreshBatchesDiv">
                    <button pButton  class="refreshBatches h-2rem" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
                  </div>
                  <div class="row col-12 flex p-0 justify-content-between" id="datePicker">
                    <div class="col-6 p-1">
                      <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                       [dateFormat]="dateFormat" [showIcon]="true" placeholder="From"
                        showButtonBar="true" (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()"
                        [maxDate]="toDate"></p-calendar>
                    </div>
                    <div class="col-6 p-1">
                      <p-calendar [(ngModel)]="toDate" [minDate]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                        [dateFormat]="dateFormat" [showIcon]="true" placeholder="To"
                        showButtonBar="true" (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()"></p-calendar>
                    </div>
                  </div>
                  <div class="row col-12 flex" style=" margin-left: 1%;">
                    <label class="m-0">Number Of Batches Matching Filter: <label class="m-0 font-bold text-success"
                        style="font-size: 1.2rem;">{{batches == null ? 0: batches.length}}</label></label>
                  </div>
                  <p-table [value]="batches" selectionMode="single" [scrollable]="true" scrollHeight="80vh"
                    (onRowSelect)="batchViewVisbility($event)" [loading]="loading">
                    <ng-template pTemplate="header">
                      <tr>
                        <th scope="col" style="width: 40%;" class="batch">Batch ID</th>
                        <th scope="col" class="status">Status</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-batch>
                      <tr [pSelectableRow]="batch">

                        <td style="width: 40%;"
                          [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                          {{batch?.batchID}}</td>
                        <td
                          [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                          {{batch?.statusOfTheBatch}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>

            <div [class]="showFilter ? 'col-1 pr-0' : 'col-3 pr-0 float-right'">
              <p-toggleButton [(ngModel)]="showFilter" onLabel="" offLabel="" onIcon="fa fa-chevron-circle-left"
              offIcon="fa fa-chevron-circle-right" [style]="{'width':'96%','height':'2.5rem','margin-top':'20rem'}"></p-toggleButton>
            </div>

            </div>
          </div>

          <div [class]="showFilter ? 'col-9' :'col-11'" style=" border-left: 1px solid #186BA0;">
            <div class="col-12 flex" id="topGroup">
              <div class="col-4" style="padding: 0% 0% 2% 0%;">
                <div class="ui-inputgroup userIdLable" style="margin-top: 10px;">
                  <button pButton class="theme-button noHover labelButton" type="button" label="User ID" style="width: 44%;"></button>
                  <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4"
                    style="width: 50%; border-radius: 1px; height: 32px;" placeholder="User ID" />
                </div>
                <div class="flex ui-inputgroup userIdLable" style="margin-top: 10px;">
                  <div style="width:44%">
                  <p-dropdown  [style]="{'width':'101%'}"  placeholder="Choose Search"
                  [options]="searchFilterList"  name="searchFilterList" [(ngModel)]="selectedSearchFilter">
                  </p-dropdown></div>
                  <input pInputText name="SearchSample" [(ngModel)]="valueToSearch" size="17"
                  (keydown.enter)="searchForBatchWIthFilter()" style=" border-radius: 1px;width: 50%; height: 33px;" />
                  <button pButton icon="fa fa-search" style="width: 5%; height: 33px;" [disabled]="searchButtonDisabledIf()"  (click)="searchForBatchWIthFilter()">
                  </button>
              </div>
              </div>
                <div class="col-5 topDivspacing" style="text-align:left;margin: 0px 0px 3px;padding: 0% 0% 2%;">
                <div class="col-12 flex headers topDivspacing" style="height: 32px;" id="topDiv">
                  <div class="col-3">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                      Batch</h5> </div>
                      <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                      <h5>
                      :
                  </h5>
                </div>
                  <div class="col-8">
                    <h5 style="color:#1F89CE; font-size: 19px;">
                    <strong style="margin: 3%;">{{selectedBatch?.batchID}}</strong>
                    </h5>
                  </div>
                </div>
                <div class="col-12 flex headers" style="height: 32px;">
                  <div class="col-3">
                  <h5  style="color:#1F89CE; font-size: 19px;">
                      Status
                    </h5></div>
                    <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                      <h5>
                      :
                  </h5>
                </div>
                    <div class="col-8">
                      <h5 style="color:#1F89CE; font-size: 19px;">
                      <strong style="margin: 3%;">{{selectedBatch?.statusOfTheBatch}} </strong>
                    </h5>
                    </div>
                </div>
                <div class="col-12 flex headers" style="height: 32px;">
                  <div class="col-3">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                      Sender
                    </h5></div>
                    <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                      <h5>
                      :
                  </h5>
                </div>
                    <div class="col-8">
                      <h5 style="color:#1F89CE; font-size: 19px;">
                        <strong style="margin: 3%;">{{getfunction()}} </strong>
                    </h5>
                  </div>
              </div>
                <div  class="col-12 flex headers" style="height: 32px;">
                  <div class="col-3">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                      Samples  </h5></div>
                      <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                        <h5>
                        :
                    </h5>
                  </div>
                    <div class="col-8">
                      <h5 style="color:#1F89CE; font-size: 19px;">
                      <strong style="margin: 3%;">{{getSamplesCount()}} </strong>
                    </h5>
                  </div>
              </div>
                <div  class="col-12 flex headers" style="height: 32px;">
                  <div class="col-3">
                  <h5 style="color:#1F89CE; font-size: 19px; width: 120px;">
                      External Id </h5></div>
                      <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                        <h5>
                        :
                    </h5>
                  </div>
                    <div class="col-8">
                      <h5 style="color:#1F89CE; font-size: 19px;">
                      <strong style="margin: 3%;">{{selectedBatch?.externalIdentification}} </strong>
                    </h5>
                  </div>
              </div>
            </div>
            <div class="col-3 topDivspacing pl-0">
              <div class="ui-inputgroup pl-0 flex" id="inputClass">
                <div>
                <button pButton class="w-full theme-button noHover labelButton" type="button" label="History"></button> </div>
                <div style="width: 52%;">
                  <p-dropdown *ngIf="selectedBatch.wellType == 'WELL384'"  [options]="groupedBatches" [(ngModel)]="batchHistoryId"
                  placeholder="Select a Batch" [group]="true" (onChange)="searchBatch()" scrollHeight="500px">
                  <ng-template let-group pTemplate="group">
                    <div class="p-d-flex p-ai-center mt-2">
                      <span>{{group.label}}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <p-dropdown *ngIf="selectedBatch.wellType == 'WELL96'"  [options]="batchHistory" [(ngModel)]="batchHistoryId"
                  placeholder="Select a Batch"  (onChange)="searchBatch()">
                </p-dropdown></div>
              </div>
              <div>
                <button pButton [icon]="getViewPlateIcon(showPlateView)"  [ngStyle]="buttonsRound" [label]="getPlateViewButtonLabel(showPlateView)"
                  id="plateView" (click)="togglePlateView()" [disabled]="!selectedBatch.batchID || deactivatePlateView"></button>
              </div>
            </div>
          </div>

            <div class="col-12 flex" id="tableDiv" [hidden]="showPlateView">
              <fieldset [disabled]="selectedBatch.workflowGroup != 'Midplex'">
                <legend></legend>

              <div class="col-12 flex" id="tableDiv">
                <table aria-describedby="Processing table" id="processingTable"
                  style="border: 1px solid black; width: 100%; height: 100%; table-layout: fixed;">
                  <thead id="processingTableHeader">
                    <tr>
                      <th scope="col">Batch Reception</th>
                      <th scope="col">Tag PCR</th>
                      <th scope="col">Purification</th>
                      <th scope="col">Data Analysis</th>
                    </tr>
                  </thead>
                  <tbody class="processingTableBody" >
                    <tr>
                      <td class="processingTableBody"  [ngClass]="{ 'disableTD': enableIfStatusIn(['BATCH_UPLOADED'])}">
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton label="Receive Batch"  (click)="saveBatchStatus('BATCH_RECEIVED')" [disabled]="enableIfStatusIn(['BATCH_UPLOADED']) || disableReceiveBatch()"
                              class="buttonsRound shadow-sm thirdButton"></button>
                          </div>
                          <div class="col-4 px-2">
                              {{selectedBatch?.batchReceivedDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.batchReceivedPUID}}
                          </div>
                        </div>
                      </td>

                      <td class="processingTableBody" rowspan="4" [ngClass]="{ 'disableTD': enableIfStatusIn(['START_TAG_PCR', 'COMPLETE_POOLING'])}">
                        <div class="col-12 parent">
                          <div class="col-12 flex parent" style="padding-bottom: 3%;">
                              <div class="col-8 child">
                                <button pButton label="Start Tag PCR" [disabled]="enableIfStatusIn(['START_TAG_PCR', 'COMPLETE_POOLING']) || disableStartTagPCR()"
                                  class="buttonsRound shadow-sm startButton" (click)="saveBatchStatus('START_TAG_PCR')" >
                                  </button>
                              </div>

                              <div class="col-4 px-2">
                                {{selectedBatch?.startTagPCRDateTime | date: dateTimeFormat}} <br />
                                {{selectedBatch?.startTagPCRPUID}}
                              </div>
                          </div>
                          <div class="ui-input-parent">
                            <div class="ui-inputgroup flex h-3rem" id="inputClass">
                              <label class="w-2 p-1"><strong>A1</strong></label>
                              <p-dropdown [style]="getDropdownStyle()" placeholder="Select Tag Plate"
                                [options]="tags"  [(ngModel)]="selectedTagPlateA1" (onChange)="checkTagPlatesDuplicates(selectedTagPlateA1,'onchange')"
                                name="LightCyclers" [disabled]="(!this.selectedBatch.mergedBatches || !this.selectedBatch.mergedBatches[0]) || selectedBatch.statusOfTheBatch !== 'START_TAG_PCR'" id="midPlexTagDropdowns"></p-dropdown>
                              <button pButton class="theme-button noHover labelButton h-3rem" disabled type="button" label="Tag Plate" ></button>
                            </div>
                            <div class="ui-inputgroup flex h-3rem" id="inputClass">
                              <label class="w-2 p-1"><strong>A2</strong></label>
                              <p-dropdown [style]="getDropdownStyle()" placeholder="Select Tag Plate"
                                [options]="tags" [(ngModel)]="selectedTagPlateA2" (onChange)="checkTagPlatesDuplicates(selectedTagPlateA2,'onchange')"
                                name="LightCyclers" [disabled]="(!this.selectedBatch.mergedBatches || !this.selectedBatch.mergedBatches[1]) || selectedBatch.statusOfTheBatch !== 'START_TAG_PCR'" id="midPlexTagDropdowns"></p-dropdown>
                              <button pButton class="theme-button noHover labelButton h-3rem" disabled type="button" label="Tag Plate"></button>
                            </div>
                            <div class="ui-inputgroup flex h-3rem" id="inputClass">
                              <label class="w-2 p-1"><strong>B1</strong></label>
                              <p-dropdown [style]="getDropdownStyle()" placeholder="Select Tag Plate"
                                [options]="tags"  [(ngModel)]="selectedTagPlateB1" (onChange)="checkTagPlatesDuplicates(selectedTagPlateB1,'onchange')"
                                name="LightCyclers" [disabled]="(!this.selectedBatch.mergedBatches || !this.selectedBatch.mergedBatches[2]) || selectedBatch.statusOfTheBatch !== 'START_TAG_PCR'" id="midPlexTagDropdowns"></p-dropdown>
                              <button pButton class="theme-button noHover labelButton h-3rem" disabled type="button" label="Tag Plate"></button>
                            </div>
                            <div class="ui-inputgroup flex h-3rem" id="inputClass">
                              <label class="w-2 p-1"><strong>B2</strong></label>
                              <p-dropdown [style]="getDropdownStyle()" placeholder="Select Tag Plate"
                                [options]="tags"  [(ngModel)]="selectedTagPlateB2" (onChange)="checkTagPlatesDuplicates(selectedTagPlateB2,'onchange')"
                                name="LightCyclers" [disabled]="(!this.selectedBatch.mergedBatches || !this.selectedBatch.mergedBatches[3]) || selectedBatch.statusOfTheBatch !== 'START_TAG_PCR'" id="midPlexTagDropdowns"></p-dropdown>
                              <button pButton class="theme-button noHover labelButton h-3rem" disabled type="button" label="Tag Plate"></button>
                            </div>
                          </div>

                          <div class="col-12 flex parent">
                            <div class="col-8 child">
                              <button pButton label="Assign Tag Plates"  [disabled]="enableIfStatusIn(['START_TAG_PCR', 'COMPLETE_POOLING']) || disableAssignTagPlate() || checkForTagPlateDuplicate"
                                class="buttonsRound shadow-sm thirdButton" (click)="openAssignTagPlatePopup()"></button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.assignTagPlateDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.assignTagPlatePUID}}
                            </div>
                          </div>
                          <div class="col-12 flex table-responsive">
                            <table class="table table-bordered m-0" aria-describedby="tag plate barcodes" aria-hidden="true">
                              <caption class="p-0">Tag Plate Barcodes</caption>
                              <tbody>
                              <tr>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[0]?.tagPlateBarcode : ''}}</td>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[1]?.tagPlateBarcode : ''}}</td>
                              </tr>
                              <tr>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[2]?.tagPlateBarcode : ''}}</td>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[3]?.tagPlateBarcode : ''}}</td>
                              </tr>
                            </tbody>
                            </table>
                          </div>
                          <div class="col-12 flex parent">
                            <div class="col-8 child">
                              <button pButton label="Complete Tag PCR"  [disabled]="enableIfStatusIn(['COMPLETE_POOLING', 'START_TAG_PCR']) || disableCompleteTagPCR()"
                                class="buttonsRound shadow-sm thirdButton" (click)="saveBatchStatus('COMPLETE_TAG_PCR')"></button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.completeTagPCRDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.completeTagPCRPUID}}
                            </div>
                          </div>
                      </div>
                      </td>
                      <td class="processingTableBody"  rowspan="2" [ngClass]="{ 'disableTD': enableIfStatusIn(['START_PURIFICATION', 'COMPLETE_LIB_POOLING'])}">
                        <div class="col-12 parent">
                          <div class="col-12 flex parent">

                            <div class="col-8 child">
                              <button pButton label="Start Purification" [disabled]="enableIfStatusIn(['START_PURIFICATION', 'COMPLETE_LIB_POOLING']) || disableStartPurification()"
                                class="buttonsRound shadow-sm startButton" (click)="saveBatchStatus('START_PURIFICATION')">
                              </button>
                            </div>

                            <div class="col-4 px-2">
                              {{selectedBatch?.startPurificationDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.startPurificationPUID}}
                            </div>
                          </div>
                          <div class="col-12 flex flex parent">
                            <div class="col-8 child">
                              <button pButton label="Complete Purification" [disabled]="enableIfStatusIn(['START_PURIFICATION', 'COMPLETE_LIB_POOLING']) || disableCompletePurification()"
                                class="buttonsRound shadow-sm thirdButton" (click)="saveBatchStatus('COMPLETE_PURIFICATION')"></button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.completePurificationDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.completePurificationPUID}}
                            </div>
                          </div>
                          <div class="col-12 flex flex parent">
                            <div class="col-8 child">
                              <button pButton label="Create Pool Library" (click)="createPoolIdForTheBatch()"
                                class="buttonsRound startButton"
                                [disabled]="disableCreateSampleButton()">
                              </button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.nglimsSampleCreationDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.nglimsSampleCreationPUID}}
                            </div>
                        </div>
                        <div class="col-12 flex flex table-responsive">
                          <table class="table table-bordered m-0" aria-describedby="tag plate barcodes" aria-hidden="true">
                            <caption class="p-0">Library Id</caption>
                            <tbody>
                            <tr>
                              <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[0]?.libraryId : ''}}</td>
                              <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[1]?.libraryId : ''}}</td>
                            </tr>
                            <tr>
                              <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[2]?.libraryId : ''}}</td>
                              <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ? selectedBatch.mergedBatches[3]?.libraryId : ''}}</td>
                            </tr>
                          </tbody>
                          </table>
                        </div>
                        </div>
                      </td>
                      <td class="processingTableBody"  rowspan="5" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_SEQUENCING_RUN','START_DATA_REVIEW','COMPLETE_DATA_REVIEW'])}">
                        <div class="col-12 flex parent">

                          <div class="col-8 child">
                            <button pButton label="Tag Sorting File" style="width: 101%;" [disabled]="enableIfStatusIn(['COMPLETE_SEQUENCING_RUN']) || disableTagSortingFile()"
                            class="buttonsRound shadow-sm thirdButton"(click)="createTagSortingFile()"></button>
                          </div>
                          <div class="col-4 px-2" style="padding: 2% 0% 1% 3%;">
                            {{selectedBatch?.tagSortingFileDateTime  | date: dateTimeFormat}} <br />
                            {{selectedBatch?.tagSortingFilePUID}}
                          </div>
                        </div>
                          <div class="col-12 flex wrapWordForMidplex" *ngIf="selectedBatch?.midplexTagSortingFileName ">
                            <a href="javascript:void(0);" (click)="downloadTagSort(selectedBatch?.midplexTagSortingFileName)"><u>{{selectedBatch?.midplexTagSortingFileName}}</u></a>

                        </div>
                        <div class="col-12 flex parent">

                          <div class="col-8 child">
                            <p-fileUpload #fileUploader [style]="getFileUploadStyle()" (uploadHandler)="onCSVUpload($event, fileUploader)" mode="basic"
                            customUpload="true" accept=".tsv" chooseLabel="Upload SNP Results" (onSelect)="onFileSelect($event)" [disabled]="selectedBatch?.statusOfTheBatch != 'COMPLETE_SEQUENCING_RUN'" auto="true"></p-fileUpload>
                          </div>

                          <div class="col-4 px-2">
                            {{selectedBatch?.snpResultUploadDateTime  | date: dateTimeFormat}} <br />
                            {{selectedBatch?.snpResultUploadPUID}}
                          </div>
                        </div>

                        <div class="col-12 flex parent mt-5">
                          <div class="col-8 child">
                            <button pButton label="Start Data Review" [disabled]="enableIfStatusIn(['COMPLETE_SEQUENCING_RUN', 'START_DATA_REVIEW']) || disableStartDataReview()"
                              class="buttonsRound shadow-sm startButton" (click)="saveBatchStatus('START_DATA_REVIEW')"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.startDataReviewDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.startDataReviewPUID}}
                          </div>
                        </div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton label="Complete Data Review" (click)="commentPopup=true"
                              [disabled]="enableIfStatusIn(['COMPLETE_SEQUENCING_RUN', 'START_DATA_REVIEW']) || disableCompleteDataReview()"
                              class="buttonsRound shadow-sm endButton"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.readyForDeliveryDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.readyForDeliveryPUID}}
                          </div>
                        </div>
                        <div *ngIf="selectedBatch.readyForDeliveryDateTime && selectedBatch.readyForDeliveryPUID" class="col-12 flex table-responsive">
                          <table class="table table-bordered m-0" aria-hidden="true">
                            <caption class="p-0">Source batches status</caption>
                            <tbody>
                              <tr>
                                <td class="text-center text-white p-0" [style.background-color]="getBackgroundColor(selectedBatch.mergedBatches[0]?.finalResult)" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ?
                                  selectedBatch.mergedBatches[0]?.batchId : ''}}</td>
                                <td class="text-center text-white p-0" [style.background-color]="getBackgroundColor(selectedBatch.mergedBatches[1]?.finalResult)" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ?
                                  selectedBatch.mergedBatches[1]?.batchId : ''}}</td>
                              </tr>
                              <tr>
                                <td class="text-center text-white p-0" [style.background-color]="getBackgroundColor(selectedBatch.mergedBatches[2]?.finalResult)" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ?
                                  selectedBatch.mergedBatches[2]?.batchId : ''}}</td>
                                <td class="text-center text-white p-0" [style.background-color]="getBackgroundColor(selectedBatch.mergedBatches[3]?.finalResult)" style="width: 50%;height: 20px;">{{selectedBatch.mergedBatches ?
                                  selectedBatch.mergedBatches[3]?.batchId : ''}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-12 flex parent mt-5">
                          <div class="col-8 child">
                            <button pButton label="Delivered" disabled
                              class="buttonsRound shadow-sm thirdButton"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.deliveryCompletionDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.deliveryCompletionPUID}}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['BATCH_RECEIVED'])}">
                        <div class="border-bottom headerDiv text-center">Add Controls</div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton  label="Controls Added"  (click)="saveBatchStatus('CONTROLS_ADDED')" [disabled]="enableIfStatusIn(['BATCH_RECEIVED']) || disableControlsAdded()"
                              class="buttonsRound shadow-sm thirdButton"></button>
                          </div>
                          <div class="col-4 px-2">
                              {{selectedBatch?.controlsAddedDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.controlsAddedPUID}}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['CONTROLS_ADDED'])}">
                        <div class="border-bottom headerDiv text-center">Merge 384</div>
                          <div class="col-12 flex parent">
                            <div class="col-8 child">
                              <button pButton [ngStyle]="buttonsRound" style="background-color: rgb(65, 130, 126);border: none;" label="{{labelFunctionMergingDefined()}}" disabled
                                class=" shadow-sm startButton"></button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.mergeDefinedDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.mergeDefinedPUID}}
                            </div>
                          </div>

                          <div class="col-12 flex parent">
                            <div class="col-8 child">
                              <button pButton [ngStyle]="buttonsRound" label="{{labelFunctionMergedCompleted()}}" disabled
                                class=" shadow-sm thirdButton"></button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.mergeCompleteDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.mergeCompletePUID}}
                            </div>
                          </div>
                          <div class="col-12 flex table-responsive">
                            <table class="table table-bordered m-0" aria-describedby="merged batches" aria-hidden="true">
                              <caption class="p-0">Merged Batches</caption>
                              <tbody>
                              <tr>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.sourceBatchIds ? selectedBatch.sourceBatchIds[0] : ''}}</td>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.sourceBatchIds ? selectedBatch.sourceBatchIds[1] : ''}}</td>
                              </tr>
                              <tr>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.sourceBatchIds ? selectedBatch.sourceBatchIds[2] : ''}}</td>
                                <td class="text-center p-0" style="width: 50%;height: 20px;">{{selectedBatch.sourceBatchIds ? selectedBatch.sourceBatchIds[3] : ''}}</td>
                              </tr>
                            </tbody>
                            </table>
                          </div>
                      </td>

                      <td  class="processingTableBody pt-0 pr-0" (click)="showInputNGLIMSDataPopup($event)" [ngClass]="{ 'disableTD': enableIfStatusInForPool(['COMPLETE_TAG_PCR','START_LIB_POOLING','COMPLETE_LIB_POOLING','START_PURIFICATION','START_LIB_QC', 'COMPLETE_PURIFICATION'])}">
                        <div class="border-bottom headerDiv text-center">NGLIMS Data</div>
                        <div class="col-12 flex ">
                          <div class="col-4">
                            <div class="col-12 flex p-0"><label class="float-right">Project:</label></div>
                            <div class="col-12 flex p-0"><label class="float-right">Sample:</label></div>
                            <div class="col-12 flex p-0"><label class="float-right">Library ID:</label></div>
                          </div>
                          <div class="col-8">
                            <div class="col-12 flex p-0"><label class="float-left font-bold"> {{selectedBatch?.nglimsProjectId}}</label></div>
                            <div class="col-12 flex p-0"><label class="float-left font-bold"> {{selectedBatch?.nglimsSampleId}}</label></div>
                            <div class="col-12 flex p-0"><label class="float-left font-bold"> {{selectedBatch?.libraryId}}</label></div>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['MERGE_COMPLETE','START_PCR'])}">
                        <div class="border-bottom headerDiv text-center">PCR</div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton  label="Start  PCR" (click)="saveBatchStatus('START_PCR')" [disabled]="enableIfStatusIn(['MERGE_COMPLETE','START_PCR']) || disableStartPCR()"
                              class="buttonsRound shadow-sm startButton"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.startPcrDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.startPcrPUID}}
                          </div>
                        </div>

                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton  label="Complete  PCR"  (click)="saveBatchStatus('COMPLETE_PCR')" [disabled]="enableIfStatusIn(['START_PCR']) || disableCompletePCR()"
                              class="buttonsRound shadow-sm thirdButton"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.completePcrDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.completePcrPUID}}
                          </div>
                        </div>
                      </td>
                      <td  class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['START_LIB_QC', 'COMPLETE_PURIFICATION'])}">
                        <div class="border-bottom headerDiv text-center">Library QC</div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton  label="Start Lib QC" [disabled]="enableIfStatusIn(['START_LIB_QC', 'COMPLETE_PURIFICATION']) || disableStartLibQC()"
                              class="buttonsRound shadow-sm startButton" (click)="saveBatchOnStartLibQC()"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.startLibQCDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.startLibQCPUID}}
                          </div>
                        </div>

                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton  label="Complete Lib QC" [disabled]="enableIfStatusIn(['START_LIB_QC', 'COMPLETE_PURIFICATION']) || disableCompleteLibQC()"
                              class="buttonsRound shadow-sm thirdButton" (click)="saveBatchStatus('COMPLETE_LIB_QC')"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.completeLibQCDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.completeLibQCPUID}}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_PCR','START_POOLING'])}">
                        <div class="border-bottom headerDiv text-center">Pooling</div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton  label="Start Pooling" (click)="saveBatchStatus('START_POOLING')" [disabled]="enableIfStatusIn(['COMPLETE_PCR','START_POOLING']) || disableStartPooling()"
                              class="buttonsRound shadow-sm startButton"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.startPoolingDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.startPoolingPUID}}
                          </div>
                        </div>

                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton  label="Complete Pooling" (click)="saveBatchStatus('COMPLETE_POOLING')" [disabled]="enableIfStatusIn(['START_POOLING']) || completStartPooling()"
                              class="buttonsRound shadow-sm thirdButton"></button>
                          </div>
                          <div class="col-4 px-2">
                            {{selectedBatch?.completePoolingDateTime | date: dateTimeFormat}} <br />
                            {{selectedBatch?.completePoolingPUID}}
                          </div>
                        </div>
                        </td>

                        <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['START_LIB_POOLING', 'COMPLETE_TAG_PCR'])}">
                          <div class="border-bottom headerDiv text-center">Lib Pooling (384-->1)</div>
                          <div class="col-12 flex parent">
                            <div class="col-8 child">
                              <button pButton  label="Start Pooling" [disabled]="enableIfStatusIn(['START_LIB_POOLING','COMPLETE_TAG_PCR']) || disableStartLibPooling()"
                                class="buttonsRound shadow-sm startButton" (click)="saveBatchStatus('START_LIB_POOLING')"></button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.startLibPoolingDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.startLibPoolingPUID}}
                            </div>
                          </div>

                          <div class="col-12 flex parent">
                            <div class="col-8 child">
                              <button pButton  label="Complete Pooling" [disabled]="enableIfStatusIn(['START_LIB_POOLING','COMPLETE_TAG_PCR']) || disableCompleteLibPooling()"
                                class="buttonsRound shadow-sm thirdButton" (click)="saveBatchStatus('COMPLETE_LIB_POOLING')"></button>
                            </div>
                            <div class="col-4 px-2">
                              {{selectedBatch?.completeLibPoolingDateTime | date: dateTimeFormat}} <br />
                              {{selectedBatch?.completeLibPoolingPUID}}
                            </div>
                          </div>
                          </td>

                          <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_LIB_QC', 'TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN'])}">
                            <div class="border-bottom headerDiv text-center">Transfer to Sequencing</div>
                            <div class="col-12 flex parent">
                              <div class="col-8 child">
                                <button pButton  label="Transfer to Sequencing" [disabled]="enableIfStatusIn(['COMPLETE_LIB_QC','TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN']) || disableTransferSequencing()"
                                  class="buttonsRound shadow-sm startButton" (click)="saveBatchStatus('TRANSFER_SEQUENCING')"></button>
                              </div>
                              <div class="col-4 px-2">
                                {{selectedBatch?.transferSequencingDateTime | date: dateTimeFormat}} <br />
                                {{selectedBatch?.transferSequencingPUID}}
                              </div>
                            </div>

                            <div class="col-12 flex parent">
                              <div class="col-8 child">
                                <button pButton  label="Start Sequencing" [disabled]="enableIfStatusIn(['COMPLETE_LIB_QC','TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN']) || disableStartSequencing()"
                                  class="buttonsRound shadow-sm thirdButton" (click)="showPopUpForRunLane()"></button>
                              </div>
                              <div class="col-4 px-2">
                                {{selectedBatch?.startSequencingDateTime | date: dateTimeFormat}} <br />
                                {{selectedBatch?.startSequencingPUID}}
                              </div>
                            </div>
                              <div class="col-12 flex p-0" *ngIf="selectedBatch.runAndLaneIdInfo && selectedBatch.runAndLaneIdInfo.length > 0">
                                 Run ID: <label class="font-bold">{{selectedBatch.runAndLaneIdInfo[0].runId}}</label>  Lane:  <label class="font-bold">{{selectedBatch.runAndLaneIdInfo[0].laneId}}</label>

                            </div>

                            <div class="col-12 flex parent">
                              <div class="col-8 child">
                                <button pButton  label="Complete Run" [disabled]="enableIfStatusIn(['COMPLETE_LIB_QC','TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN']) || disableCompleteRun()"
                                  class="buttonsRound shadow-sm thirdButton" (click)="saveBatchStatus('COMPLETE_SEQUENCING_RUN')"></button>
                              </div>
                              <div class="col-4 px-2">
                                {{selectedBatch?.completedSequencingDateTime | date: dateTimeFormat}} <br />
                                {{selectedBatch?.completedSequencingPUID}}
                              </div>
                            </div>
                          </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="processingTableBody pt-0 pr-0">
                        <div class="border-bottom headerDiv text-center">Comments</div>
                        <div class="col-12" style="height: 100%; ">
                          <div class="col-12 flex">
                          <div class="col-6 p-0 text-left">
                            <label class="font-bold commentBatchId">{{previewComment?.batchId}}</label>
                          </div>
                          <div class="col-6 p-0 text-right">
                            <label class="commentPUIDDate">{{previewComment?.puid}} | {{previewComment?.commentDate | date: dateTimeFormat}}</label>
                          </div>
                        </div>
                          <textarea [(ngModel)]="previewComment.userComment" type="text" name="comment"
                            placeholder="No comments entered" rows="5" id="commentArea" readonly></textarea>
                          <button style="margin-top: 2%;" pButton class="font-bold commentButton" [disabled]="isCommentAdditionDisabled()" label="View/Add Comments" (click)="showComments()"></button>
                        </div>
                      </td></tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
            </div>
            <div class="col-12 flex p-0" [hidden]="!showPlateView">
              <app-plate-view #plateView *ngIf="showPlateView" [selectedBatch]="selectedBatch" [puid]="puid" [selectedLabId]="selectedLabId" [totalPCRControls]="totalPCRControls"
               [showPlateView]="showPlateView" [viewMode]="plateViewMode" [sourceBatchSamplesMap]="sourceBatchSamplesMap"></app-plate-view>
          </div>
          </div>
      </div>
    </div>
  </div>
  <p-dialog header="Enter Tag Plate Barcode" [(visible)]="assignTagPlatePopup" [dismissableMask]="true"
      [modal]="true" (onHide)="resetTagPlateBarcodeInputs()">
  <label class="text-danger">Scan the barcode of the Tag Plate(s)</label>
  <div class="ui-inputgroup mt-2">
    <button pButton class="theme-button noHover labelButton" type="button" label="A1"></button>
    <input class="batchInput" id="enteredScanPlateBarcode"  pInputText  type="text"
    [(ngModel)]="tagPlateBarcodeA1" maxlength="100" name="comment" #focus
     placeholder="Enter Tag Plate Barcode" />
  </div>
  <div class="ui-inputgroup mt-2">
    <button pButton class="theme-button noHover labelButton" type="button" label="A2"></button>
    <input class="batchInput" id="enteredScanPlateBarcode"  pInputText  type="text"
    [(ngModel)]="tagPlateBarcodeA2" maxlength="100" name="comment" [disabled]="!(this.selectedBatch.mergedBatches && selectedBatch.mergedBatches[1])"
     placeholder="Enter Tag Plate Barcode" />
  </div>
  <div class="ui-inputgroup mt-2">
    <button pButton class="theme-button noHover labelButton" type="button" label="B1"></button>
    <input class="batchInput" id="enteredScanPlateBarcode"  pInputText  type="text"
    [(ngModel)]="tagPlateBarcodeB1" maxlength="100" name="comment" [disabled]="!(this.selectedBatch.mergedBatches && selectedBatch.mergedBatches[2])"
     placeholder="Enter Tag Plate Barcode" />
  </div>
  <div class="ui-inputgroup mt-2">
    <button pButton class="theme-button noHover labelButton" type="button" label="B2"></button>
    <input class="batchInput" id="enteredScanPlateBarcode"  pInputText  type="text"
    [(ngModel)]="tagPlateBarcodeB2" maxlength="100" name="comment" [disabled]="!(this.selectedBatch.mergedBatches && selectedBatch.mergedBatches[3])"
     placeholder="Enter Tag Plate Barcode" />
  </div>
  <div class="mt-5">
    <input class="batchInput" size="27" id="enteredPuid"  pInputText  type="text" [(ngModel)]="enteredPuid" maxlength="100" name="comment"
     placeholder="Enter User ID"  />
  </div>
  <div class="mt-2">
    <input class="batchInput" size="27" pInputText type="password" [(ngModel)]="enteredPassword" maxlength="100"
     name="comment12" placeholder="Enter Password" (keyup.enter)="assignTagPlateBarcodes()" />
  </div>
  <p-footer>
    <button pButton type="button" [disabled]="assignButtonDisabled()" label="Assign" (click)="assignTagPlateBarcodes()"></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="inputPopup" [dismissableMask]="true" [showHeader]="false" [modal]="true" (onHide)="clearNGLIMSInputFields()">
  <div *ngIf="enableIfStatusIn(['TRANSFER_SEQUENCING','START_SEQUENCING_RUN'])">
    <div class="ui-inputgroup">
      <button pButton class="theme-button noHover labelButton popupWidth" type="button" label="Project"></button>
      <input class="batchInput"  pInputText  type="text"
      [(ngModel)]="enteredProjectId" maxlength="100"
       placeholder="Enter NGLIMS Project ID" (change)="enteredProjectId=enteredProjectId.trim()"/>
    </div>
    <div class="ui-inputgroup mt-2">
      <button pButton class="theme-button noHover labelButton popupWidth" type="button" label="Sample"></button>
      <input class="batchInput"  pInputText  type="text"
      [(ngModel)]="enteredSampleName" maxlength="100" (change)="enteredSampleName=enteredSampleName.trim()"
       placeholder="Enter NGLIMS Sample">
    </div>
    <div class="ui-inputgroup mt-2">
      <button pButton class="theme-button noHover labelButton popupWidth" type="button" label="Library ID"></button>
      <input class="batchInput" pInputText  type="text"
      [(ngModel)]="enteredLibraryId" maxlength="100" (change)="enteredLibraryId=enteredLibraryId.trim()"
       placeholder="Enter NGLIMS Library ID" />
    </div>
  </div>
  <div *ngIf="!enableIfStatusIn(['TRANSFER_SEQUENCING','START_SEQUENCING_RUN'])">
    <div class="ui-inputgroup">
      <button pButton class="theme-button noHover labelButton popupWidth" type="button" label="Run ID"></button>
      <input class="batchInput"  pInputText  type="text"
      [(ngModel)]="enteredRunId" maxlength="100" (change)="enteredRunId=enteredRunId.trim()"
       placeholder="Enter Run ID" />
    </div>
    <div class="ui-inputgroup mt-2">
      <button pButton class="theme-button noHover labelButton popupWidth" type="button" label="Lane"></button>
      <input class="batchInput"  pInputText  type="text"
      [(ngModel)]="enteredLane" maxlength="100" (change)="enteredLane=enteredLane.trim()"
       placeholder="Enter Lane">
    </div>
  </div>
  <p-footer>
    <button pButton type="button" [disabled]="saveNGLIMSButtonDisabledIf()" icon="pi pi-check" label="Save" (click)="saveNGLIMSInfo()"></button>
  </p-footer>
</p-dialog>
<p-dialog header="Confirmation" [(visible)]="commentPopup" [modal]="true" [dismissableMask]="true">
  <label class="font-bold">Select appropriate option to proceed: </label>

  <p-footer>
    <button pButton class="bg-success" label="QC OK => Continue"  (click)="saveBatchStatus('COMPLETE_DATA_REVIEW')"></button>
    <button pButton class="bg-danger" label="QC Failed => Redo Sequencing" (click)="redoSequencing()"  ></button>
    <button pButton class="bg-danger" label="QC Failed => Redo Merging" (click)="showQCOverlay($event,op)"  ></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{selectedBatch.batchID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true">
  <div class="border border-info" id="commentShowDiv">
    <div class="col-12" *ngFor="let batch of getCommentKeys(commentsMap)">
      <div class="col-12 p-0 rounded border border-secondary commentBubble">
        <div class="col-12 flex">
          <div class="col-11 pb-0">
            <label>{{batch}}</label>
          </div>
          <div class="col-1 pb-0">
            <button *ngIf="batchCommentVisibility.get(batch)" type="button" class="float-right btn btn-outline-secondary border-0 p-0" (click)="toggleBatchContent(batch, false)"><em class="fa fa-window-minimize"></em></button>
            <button *ngIf="!batchCommentVisibility.get(batch)" type="button" class="float-right btn btn-outline-secondary border-0 p-0" (click)="toggleBatchContent(batch, true)"><em class="fa fa-window-maximize"></em></button>
          </div>
        </div>
        <div *ngIf="batchCommentVisibility.get(batch)">
          <div *ngFor="let comment of commentsMap.get(batch)">
            <div class="col-12 p-0 commentBubbleSection">
              <div class="col-12 commentPUIDDate">
                <label>{{comment.puid}} | {{comment.commentDate | date: dateTimeFormat}}</label>
              </div>
              <div class="col-12 commentPUIDDate font-bold">
                <p>{{comment.userComment}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..." [(ngModel)]="this.newComment.userComment"></textarea>
  </div>
  <p-footer>
    <button pButton class="h-2rem border-round" label="Add Comment" [disabled]="!(newComment.userComment != null && newComment.userComment.trim() != '')" (click)="saveComment()"></button>
  </p-footer>
</p-dialog>

<p-overlayPanel #op>
  <div class="col-12 flex p-0">
<div class=col-12 flex *ngFor="let mergedBatch of selectedBatch.mergedBatches">
  <div class="col-8 p-0 text-center">
    <label class="mb-0 font-bold text-center">{{mergedBatch.quadrant}} : {{mergedBatch.batchId}}</label>
  </div>
  <div class="col-4 p-0">
    <button pButton style="width: 70%;float: left;color: white;" [class]="mergedBatch.finalResult === 'QC OK' ? 'bg-success' : 'bg-danger'" [label]="mergedBatch.finalResult"  (click)="toggleQCStatus(mergedBatch)"></button>
  </div>
</div>

<button pButton class="float-right mt-3" label="Submit" [disabled]="disableRedoMerging()"  (click)="redoMerging(op)"></button>
</div>
</p-overlayPanel>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
